<script lang="ts">
  import moment from "moment";
  import type { Storefront } from "app/javascript/shared/javascripts/types/Storefront";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import StorefrontPublishedModal from "../Components/StorefrontPublishedModal.svelte";
  import EditorErrors from "../Components/Editor/EditorErrors.svelte";
  export let callbacks: any;
  export let storefront: Storefront;
  export let loading: boolean;

  let showPublishModal = false;

  function onClickNavPublish() {
    showPublishModal = true;
  }

  function onClosePublishModal() {
    showPublishModal = false;
  }

  function formatDate(d) {
    //@ts-ignore
    return moment(d).format("MMM D, YYYY hh:mm a");
  }

  const goBackToDashboard = () => {
    window.location.href = "/distributor/storefronts";
  };
</script>

<nav class="fizz-subnav" data-grid-area="nav">
  <div class="fizz-space-between fizz-wrapper-large">
    <div class="fizz-flex-row">
      <button
        class="fizz-button fizz-button-icon-left fizz-flex-row-4"
        on:click={goBackToDashboard}
      >
        <Icon type="ArrowLeft" height="16" width="16"></Icon>
        <span>Exit</span>
      </button>
      <div>
        <h1 class="fizz-heading-3">Edit Storefront</h1>
        <div class="fizz-text-small">
          {#if loading}
            Saving Changes...
          {:else if storefront.previously_published_at && (storefront.status == "published" || storefront.dirty == false)}
            Last Published: {formatDate(storefront.previously_published_at)}
          {:else}
            Autosaved: {formatDate(storefront.updated_at)}
          {/if}
        </div>
      </div>
    </div>
    <div class="fizz-flex-row">
      <div class="fizz-hide-on-small fizz-flex-row">
        <UIRouterLink
          stateName="layout.storefronts_preview"
          classes="default-subheader--regular nounderline-hover"
          params={{ distributor_id: storefront.distributor_id }}
        >
          <button class="fizz-button">Preview</button>
        </UIRouterLink>
        <button class="fizz-button-primary" on:click={onClickNavPublish}>Publish</button>
      </div>
      <a
        href="https://support.provi.com/s/topic/0TODn000000YINAOA4/storefronts"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon type="Question" height="24" width="24"></Icon>
      </a>
    </div>
  </div>
  <div class="fizz-space-between fizz-sticky-bottom fizz-hide-on-large">
    <UIRouterLink
      stateName="layout.storefronts_preview"
      classes="default-subheader--regular nounderline-hover"
      params={{ distributor_id: storefront.distributor_id }}
    >
      <button class="fizz-button">Preview</button>
    </UIRouterLink>
    <button class="fizz-button-primary" on:click={onClickNavPublish}>Publish</button>
  </div>
</nav>

<StorefrontPublishedModal {showPublishModal} {storefront} {callbacks} {onClosePublishModal}
></StorefrontPublishedModal>
<EditorErrors {storefront} {callbacks}></EditorErrors>
